module.exports = __webpack_public_path__ + "static/violet-rose-cosmic-crystal-fdcf8e041096bb550cbf76ad6093e5ee.jpg";